export const environment = {
  production: true,
  apiUrl: 'https://kronos.tarento.com/api/v1/',
  apiUrl1: 'https://kronos.tarento.com/api/',
  styria: {
    gateway: 'https://styria-dev.tarento.com/',
    integrationServiceVersion: 'v1/'
  }
};
